import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import GeneralSettingsComponent from '../components/settings/GeneralSettings.js';
import { useAuth } from '../context/AuthContext.js';

const GeneralSettings = () => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return (
      <div className="min-h-screen bg-harmony-blue p-6">
        <div className="max-w-4xl mx-auto bg-harmony-blue-dark p-8 rounded-lg shadow-lg">
          <h1 className="text-2xl font-bold text-harmony-white mb-4">General Settings</h1>
          <p className="text-harmony-white/70">Please log in to access your general settings.</p>
          <Link to="/login" className="mt-4 inline-block bg-harmony-orange text-harmony-white px-4 py-2 rounded hover:bg-harmony-orange/90">
            Log In
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-harmony-blue p-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <Link 
            to="/settings" 
            className="text-harmony-white/70 hover:text-harmony-white flex items-center"
          >
            <FiArrowLeft className="mr-2" /> Back to Settings
          </Link>
        </div>
        
        <motion.h1 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          className="text-3xl font-bold text-harmony-white mb-6"
        >
          General Settings
        </motion.h1>
        
        <div className="bg-harmony-blue-dark rounded-lg p-6 shadow-lg border border-harmony-white/10">
          <GeneralSettingsComponent />
        </div>
      </div>
    </div>
  );
};

export default GeneralSettings; 